import React from 'react';

import { Navigate } from 'react-router-dom';

import { useAuthStore } from '../store/useAuthStore.ts';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const {isAuthenticated} = useAuthStore();

  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
